
























import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import CircleChart from '../chart/CircleChart.vue'

@Component({
  components: { Status, CircleChart },
  props: {
    status: {
      type: Number,
      required: true
    },
    showCompleteCircle: {
      type: Boolean,
      default: false
    },
    toolTipText: {
      type: String,
      default: ''
    }
  }
})
export default class StatusFacilityComplete extends Vue {
  get type (): EStatusType {
    if (this.$props.status < 30) {
      return EStatusType.error
    }

    if (this.$props.status >= 30 && this.$props.status < 50) {
      return EStatusType.attention
    }

    if (this.$props.status >= 50 && this.$props.status < 80) {
      return EStatusType.pending
    }

    if (this.$props.status >= 80 && this.$props.status <= 99) {
      return EStatusType.process
    }

    if (this.$props.status === 100) {
      return EStatusType.success
    }

    return EStatusType.default
  }

  get text (): string {
    return `${this.$props.status}%`
  }
}
